/* global $ */

import autocompleteSearch from './AutocompleteSearch';

// const CONTAINER_ELEMENT_CLASS = '.js-steps';
const ROW_ELEMENT_CLASS = '.js-step';
const ADD_ELEMENT_CLASS = '.js-step-add';
const REMOVE_ELEMENT_CLASS = '.js-step-remove';
const ROWS_ELEMENT_CLASS = '.js-steps-row';
const ROW_TEMPLATE = '.js-row-template';

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

const dynamicList = {

  /**
   * Initialize dynamic list
   * @param {Node} container Container node
   * @return {Void}
   */
  create(container, props) {
    this.props = props;
    this.container = container;
    this.addBtn = container.querySelector(ADD_ELEMENT_CLASS);
    this.template = container.querySelector(ROW_TEMPLATE).innerHTML;
    this.createListeners();
    this.renumber();
  },

  /**
   * Create all events for the list
   * @return {void}
   */
  createListeners() {
    // Listen for clicks on the add row button
    this.addBtn.addEventListener('click', () => {
      const el = $(this.template).get(0);

      // Add the row after the last row
      this.container.querySelector(ROWS_ELEMENT_CLASS).appendChild(el);

      window.pubsub.publish('components:evaluate');

      this.renumber();

      let autocompleteFields = this.container.querySelectorAll('[data-component="AutocompleteSearch"]');
      autocompleteFields = Array.prototype.slice.call(autocompleteFields);

      if (autocompleteFields.length) {
        autocompleteFields.forEach((field) => {
          const inst = Object.assign({}, autocompleteSearch);
          inst.create(field, field.dataset);
        });
      }
    });

    // Listen for all clicks on the container
    this.container.addEventListener('click', (e) => {
      // Check if we've clicked on the remove button
      if (e.target.className.indexOf(REMOVE_ELEMENT_CLASS.replace(/^\./, '')) < 0) {
        return true;
      }

      e.preventDefault();
      const { target } = e;

      $(target).parents(ROW_ELEMENT_CLASS).remove();

      this.renumber();

      return false;
    });
  },

  /**
   * Tiny helper function to transform NodeList to an array
   * @param {NodeList} els List of nodes
   * @param {Array} Array of nodes
   */
  nodeListToArray(els) {
    return Array.prototype.slice.call(els);
  },

  /**
   * Renumber the rows
   * @return {void}
   */
  renumber() {
    const elements = this.nodeListToArray(this.container.querySelectorAll('label, input, textarea, select'));
    const attrs = ['for', 'id', 'name', 'data-autocomplete-output'];

    elements.forEach((el) => {
      const $parent = $(el).parents(ROW_ELEMENT_CLASS);
      const index = $parent.index();

      if (!$parent.is(':visible')) {
        return;
      }

      attrs.forEach((attr) => {
        const val = el.getAttribute(attr);

        const key = this.props.id;

        if (typeof val !== 'undefined' && val) {
          const searchRegex = new RegExp(`^${escapeRegExp(key)}\\[[\\w#]+\\]`);
          const newVal = val.replace(searchRegex, `${key}[${index}]`);

          el.setAttribute(attr, newVal);
        }
      });
    });
  },
};

export default dynamicList;
